import { render, staticRenderFns } from "./PageSizeSelector.vue?vue&type=template&id=b928dd4a&"
import script from "./PageSizeSelector.vue?vue&type=script&lang=js&"
export * from "./PageSizeSelector.vue?vue&type=script&lang=js&"
import style0 from "./PageSizeSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports